const stickyPopupInit = (popup: HTMLElement) => {
  const close = popup.querySelector(".sticky-popup__close");

  close?.addEventListener("click", () => {
    popup.classList.toggle("active");
  });
};

export default stickyPopupInit;
